import { ErrorMessage, Field, Formik, Form } from 'formik';
import React, { useState } from 'react';
import FormFieldWithLabel from '../../../common/FormFieldWithLabel';
import CustomSelect from '../../../../common/formElements/CustomSelect';
import { createActionSettingsSchema, extractParameters, getFieldInfoByName } from './Util';
import CustomLoader from '../../../common/CustomLoader';
import { validationForAmazonTextract } from '../../../../common/formElements/CollectionSectionType';
import { defaultFields } from 'drapcode-constant';
export const AmazonTextractForm = ({
  projectId,
  selectedEvent,
  eventAction,
  actionData,
  events,
  actions,
  hideModal,
  showLoaderForAction,
  version,
}) => {
  const [selectedCollection, setSelectedCollection] = useState(null);
  const collectionOptions = () => {
    let options = [{ value: '', label: 'Choose Collection' }];
    let collections = events ? events.collections : [];
    if (collections.length > 0) {
      options = options.concat(
        collections.map((collection) => {
          return { value: collection.collectionName, label: collection.collectionTitle };
        }),
      );
    }
    return options;
  };

  const fieldOCROptions = (Values) => {
    let options = [{ value: '', label: 'Choose Document Field' }];
    let collections = events ? events.collections : [];
    const findCollection = (collectionName) =>
      collections.find((obj) => obj.collectionName === collectionName);
    const foundCollection = findCollection(Values.collection);
    if (foundCollection && foundCollection.fields) {
      setSelectedCollection(foundCollection);
      foundCollection.fields.forEach((field) => {
        const lowercaseFieldName = field.fieldName.toLowerCase();
        if (!defaultFields.includes(lowercaseFieldName) && lowercaseFieldName !== 'createdby') {
          options.push({ value: field.fieldName, label: field.fieldName });
        }
      });
    }
    return options;
  };
  const fieldTextOptions = (Values) => {
    let options = [{ value: '', label: 'Choose Text Field' }];
    if (selectedCollection && selectedCollection.fields) {
      selectedCollection.fields.forEach((field) => {
        const lowercaseFieldName = field.fieldName.toLowerCase();
        if (
          !defaultFields.includes(lowercaseFieldName) &&
          field.fieldName !== Values.fieldForDocument &&
          lowercaseFieldName !== 'createdby'
        ) {
          options.push({ value: field.fieldName, label: field.fieldName });
        }
      });
    }
    return options;
  };

  const handleSubmit = (values) => {
    let parameters = extractParameters(values, actionData);
    let actionFormData = eventAction;
    actionFormData.parameters = parameters;
    actions.updateAction({
      projectId,
      version,
      eventId: selectedEvent.uuid,
      data: actionFormData,
    });
    hideModal();
  };

  return (
    <Formik
      enableReinitialize={true}
      initialValues={createActionSettingsSchema(actionData, eventAction)}
      validationSchema={validationForAmazonTextract()}
      onSubmit={handleSubmit}
    >
      {({ values, setFieldValue, setFieldTouched }) => (
        <Form>
          <div className="row">
            <div className="col-12">
              <div className="form-group">
                <FormFieldWithLabel
                  cta={false}
                  label="Choose Collection"
                  icon="select"
                  infoIcon={true}
                  infoDescription="Select Collection which you want to Create Item For."
                >
                  <CustomSelect
                    name={'collection'}
                    isMulti={false}
                    onChange={setFieldValue}
                    onBlur={setFieldTouched}
                    options={collectionOptions()}
                    value={values['collection']}
                  />
                </FormFieldWithLabel>
                <ErrorMessage name={'collection'}>
                  {(msg) => <p className="text-error ml-5">{msg}</p>}
                </ErrorMessage>
              </div>
            </div>
            <div className="col-12">
              <div className="form-group">
                <FormFieldWithLabel
                  cta={false}
                  label="Select Document source field"
                  icon="select"
                  infoIcon={true}
                  infoDescription="Select Document source field where your file exists."
                >
                  <CustomSelect
                    name={'fieldForDocument'}
                    isMulti={false}
                    onChange={setFieldValue}
                    onBlur={setFieldTouched}
                    options={fieldOCROptions(values)}
                    value={values['fieldForDocument']}
                  />
                </FormFieldWithLabel>
                <ErrorMessage name={'fieldForDocument'}>
                  {(msg) => <p className="text-error ml-5">{msg}</p>}
                </ErrorMessage>
              </div>
              <div className="form-group">
                <FormFieldWithLabel
                  cta={false}
                  label="Select Text destination field"
                  icon="select"
                  infoIcon={true}
                  infoDescription={'Select Text field in which you want to save your OCR text.'}
                >
                  <CustomSelect
                    name={'fieldForText'}
                    isMulti={false}
                    onChange={setFieldValue}
                    onBlur={setFieldTouched}
                    options={fieldTextOptions(values)}
                    value={values['fieldForText']}
                  />
                </FormFieldWithLabel>
                <ErrorMessage name={'fieldForText'}>
                  {(msg) => <p className="text-error ml-5">{msg}</p>}
                </ErrorMessage>
              </div>
            </div>
            <div className="col-12">
              <div className="form-group">
                <FormFieldWithLabel
                  cta={false}
                  label="Success Message"
                  icon="text"
                  infoIcon={true}
                  infoDescription={getFieldInfoByName('successMessage')}
                >
                  <Field
                    name="successMessage"
                    type="text"
                    placeholder="(Optional) Enter custom success message."
                    className="form-control form-control-sm"
                  />
                </FormFieldWithLabel>
              </div>
            </div>
            <div className="col-12">
              <div className="form-group">
                <FormFieldWithLabel
                  cta={false}
                  label="Error Message"
                  icon="text"
                  infoIcon={true}
                  infoDescription={getFieldInfoByName('errorMessage')}
                >
                  <Field
                    name="errorMessage"
                    type="text"
                    placeholder="(Optional) Enter custom error message."
                    className="form-control form-control-sm"
                  />
                </FormFieldWithLabel>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6 text-left">
              <button
                type="button"
                className="btn btn-outline-secondary btn-sm"
                onClick={hideModal}
              >
                <span>
                  <i className="wb webconnect-times"></i>&nbsp;Cancel
                </span>
              </button>
            </div>
            <div className="col-md-6 text-right">
              <button type="submit" className="btn btn-theme-submit btn-sm">
                <i className="wb webconnect-save-regular"></i>&nbsp;Save&nbsp;
                <CustomLoader loading={showLoaderForAction} />
              </button>
            </div>
          </div>
        </Form>
      )}
    </Formik>
  );
};
